import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManageCardTemplate } from './ManageCardTemplate';
import { Button } from 'react-bootstrap';
import { ICampaignManagement } from '../../dashboard/components/dto/ICampaignManagement';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';

interface IClientsCard {
    handleOpenModal: () => void;
    managementInfo?: ICampaignManagement;
}

export const ClientsCard = ({ handleOpenModal, managementInfo }: IClientsCard) => {
    const isSupplier = managementInfo?.isSupplier;
    const team = managementInfo?.isSupplier ? managementInfo?.clientUsers : managementInfo?.assignedUsers;

    const { t } = useTranslation();
    return (
        <ManageCardTemplate
            title={
                isSupplier
                    ? t('brand.campaign.dashboard.campaign_management.client_team')
                    : t('brand.campaign.dashboard.campaign_management.agency_team')
            }
            description=""
        >
            <div className="mt-3">
                {team?.map((influencer, i) => {
                    return (
                        <div key={i} className={`d-flex align-items-center ${i > 0 ? 'mt-3' : ''}`}>
                            <CustomImageHandler
                                classes="campaign-icon rounded-circle"
                                altTag="User Profile"
                                photoPath={influencer?.profilePhoto?.thumbnail ?? ''}
                                name={influencer?.firstName}
                            />
                            <div className="ml-3 font-weight-semi-bold">
                                {influencer?.firstName} {influencer?.lastName}
                            </div>
                        </div>
                    );
                })}
                <div>
                    {isSupplier ? (
                        <Button variant="outline-primary" size="sm" onClick={handleOpenModal} className="mt-3 w-100">
                            {t('brand.campaign.manage.menageClients')}
                        </Button>
                    ) : (
                        <Button variant="outline-primary" size="sm" onClick={handleOpenModal} className="mt-3 w-100">
                            {t('brand.campaign.manage.need_assistance')}
                        </Button>
                    )}
                </div>
            </div>
        </ManageCardTemplate>
    );
};
